import { create } from 'zustand'

interface AppLoadingState {
    isAppLoading: boolean
    startAppLoading: () => void
    stopAppLoading: () => void
}

const useAppLoading = create<AppLoadingState>()(((set) => ({
    isAppLoading: false,
    startAppLoading: () => set({ isAppLoading: true }),
    stopAppLoading: () => set({ isAppLoading: false }),
})))

export default useAppLoading;
